import styled from "styled-components"

const StickyTarget = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export default StickyTarget
